<section>
  <div class="options-bar tw-flex tw-items-center">
    <button
      mat-icon-button
      type="button"
      (click)="onClickSideNavChangeButton()"
      color="primary"
    >
      <mat-icon class="icon-toolbar">menu</mat-icon>
    </button>
    <h1
      *ngIf="testEnvironment && !(fullscreen$ | async)"
      class="tw-text-white"
    >
      ESTE ES UN SITIO DE PRUEBAS
    </h1>
  </div>
  <!--  Search bar -->
  <div class="search-bar" *ngIf="!(fullscreen$ | async)">
    <app-search-toolbar></app-search-toolbar>
  </div>
  <div class="user-bar">
    <button
      mat-icon-button
      type="button"
      [matMenuTriggerFor]="menu"
      color="primary"
    >
      <mat-icon class="icon-toolbar">person</mat-icon>
    </button>
  </div>
</section>

<!-- Title-->
<div
  class="page-title"
  *ngIf="(pageTitle$ | async) && !(fullscreen$ | async)"
>
  <button
    mat-icon-button
    type="button"
    (click)="onClickBackButton()"
    *ngIf="(returnBackButton$ | async) === true"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h2 [class.add-margin]="!(returnBackButton$ | async)">
    {{ pageTitle$ | async }}
  </h2>
</div>

<!-- Sign OFF-->
<mat-menu #menu="matMenu" class="menu-sign-off">
  <mat-card class="tw-text-center tw-p-2">
    <mat-card-title>Perfil</mat-card-title>
    <mat-card-subtitle>{{ userName }}</mat-card-subtitle>
    <mat-divider class="tw-my-2"></mat-divider>
    <mat-card-footer class="tw-flex tw-px-2">
      <button
        mat-raised-button
        (click)="onClickSignOffButton()"
        class="
          tw-flex tw-flex-row tw-items-center tw-py-1 tw-w-full
          app-btn-blue
        "
      >
        <mat-icon class="icon-sign-off tw-text-center"
          >power_settings_new</mat-icon
        >
      </button>
    </mat-card-footer>
  </mat-card>
</mat-menu>
